<!-- Privacy policy -->
<ng-template #privacyPolicy>
  <div class="privacyPolicy">
    <div class="privacyPolicy__text vc-text-m">
      <span i18n="@@GET_PAID.PRIVACY_POLICY.LEARN_MORE">Learn more about the way we process your data in</span>
      <vc-ref
        class="privacyPolicy__link"
        [resource]="'/privacy-policy/?webView=' + (isWebView ? '1' : '0')"
        [anchor]="false"
        i18n="@@GET_PAID.PRIVACY_POLICY.PRIVACY_POLICY"
        >our Privacy Policy
      </vc-ref>
    </div>
    <div class="privacyPolicy__text vc-text-m" [ngClass]="{'d-none': isWebView}">
      <a
        class="privacyPolicy__link"
        href="https://faq.vestiairecollective.com/hc/en-us/articles/360015689357-Seller-Payments-are-changing-here-s-everything-you-need-to-know-"
        i18n="@@GET_PAID.STEPS.HELP_CENTER"
        i18n-href="@@GET_PAID.STEPS.HELP_CENTER_LINK"
        >Help center</a
      >
    </div>
  </div>
</ng-template>

<!-- Transfer Method Details -->
<ng-template #bankWireAccount let-bankAccountId="bankAccountId">
  <div class="transferMethod__icon">
    <vc-sprite-icons name="bank" class="transferMethod__icon__element"></vc-sprite-icons>
  </div>
  <div class="transferMethod__details">
    <div class="transferMethod__details__title vc-text-m">
      Bank account
    </div>
    <div class="transferMethod__details__content vc-text-s">
      {{ bankAccountId }}
    </div>
  </div>
</ng-template>

<ng-template #transferMethodDetails>
  <div
    *ngIf="transferMethod?.transferMethodType && showTransferMethodDetails"
    [ngSwitch]="transferMethod?.transferMethodType"
    class="transferMethod"
  >
    <ng-container *ngSwitchCase="transferMethodType.BANK_CARD">
      <div class="transferMethod__icon">
        <vc-sprite-icons name="credit-card" class="transferMethod__icon__element"></vc-sprite-icons>
      </div>
      <div class="transferMethod__details">
        <div class="transferMethod__details__title vc-text-m">
          {{ transferMethod.cardBrand === 'MASTERCARD' ? 'MasterCard' : 'Visa' }}
        </div>
        <div class="transferMethod__details__content vc-text-s">
          {{ transferMethod.cardNumber }}
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="transferMethodType.BANK_ACCOUNT">
      <ng-container
        *ngTemplateOutlet="bankWireAccount; context: {bankAccountId: transferMethod.bankAccountId}"
      ></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="transferMethodType.WIRE_ACCOUNT">
      <ng-container
        *ngTemplateOutlet="bankWireAccount; context: {bankAccountId: transferMethod.bankAccountId}"
      ></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="transferMethodType.PAYPAL_ACCOUNT">
      <div class="transferMethod__icon">
        <img class="transferMethod__icon__element" src="assets/svg/carts/paypal.svg" alt="Paypal" />
      </div>
      <div class="transferMethod__details">
        <div class="transferMethod__details__title vc-text-m">
          Paypal
        </div>
        <div class="transferMethod__details__content vc-text-s">
          {{ transferMethod.email }}
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="transferMethodType.VENMO_ACCOUNT">
      <div class="transferMethod__icon">
        <img
          class="transferMethod__icon__element transferMethod__icon__element--venmo"
          src="assets/svg/carts/venmo.svg"
          alt="Venmo"
        />
      </div>
      <div class="transferMethod__details">
        <div class="transferMethod__details__title vc-text-m">
          Venmo
        </div>
        <div class="transferMethod__details__content vc-text-s">
          {{ transferMethod.accountId }}
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<div class="sellerPayment">
  <!-- Navigation steps -->
  <nav class="stepsContainer" [ngClass]="{hide: selectedForm, isWebView: isWebView}">
    <vc-get-paid-reassurance class="reassuranceMessage" [customerKYC]="customerInfo"></vc-get-paid-reassurance>

    <ul class="steps">
      <!-- PERSONAL INFORMATION -->
      <li
        class="steps__item personalInformation"
        [ngClass]="{
          'steps__item--active': selectedForm === getPaidForms.PERSONAL_INFORMATION,
          'steps__item--warning': !customerInfo,
          'steps__item--valid': customerInfo,
          'steps__item--disabled': customerInfo
        }"
        (click)="selectForm(getPaidForms.PERSONAL_INFORMATION)"
      >
        <div class="steps__item__row">
          <vc-sprite-icons
            class="steps__item__row__icon"
            [name]="!customerInfo ? stepIcons.warning : stepIcons.valid"
          ></vc-sprite-icons>
          <div class="steps__item__row__content">
            <div
              *ngIf="!userIsB2C; else businessInformation"
              class="steps__item__row__content__title"
              i18n="@@GET_PAID.STEPS.PERSONAL_INFORMATION"
            >
              Personal information
            </div>
            <ng-template #businessInformation i18n="@@GET_PAID.STEPS.BUSINESS_INFORMATION">
              Business Information
            </ng-template>
          </div>
        </div>
        <button
          class="vc-btn vc-btn--primary vc-btn--medium d-md-none steps__item__button"
          (click)="selectForm(getPaidForms.PERSONAL_INFORMATION)"
          i18n="@@GET_PAID.STEPS.PERSONAL_INFORMATION_BUTTON"
        >
          Continue
        </button>
      </li>
      <!-- TRANSFERT METHOD -->
      <li
        class="steps__item transfertMethod steps__item--{{
          transferMethodState ? stepStatus[transferMethodState] : stepStatus.NOT_CREATED
        }}"
        [ngClass]="{
          'steps__item--active': selectedForm === getPaidForms.TRANSFERT_METHOD,
          'steps__item--disabled steps__item--deactivate': !customerInfo
        }"
        (click)="openTransferMethodForm()"
      >
        <div class="steps__item__row">
          <div class="steps__item__row__icon">
            <vc-sprite-icons
              *ngIf="stepIcons[stepStatus[transferMethodState]] !== null"
              class="steps__item__row__icon"
              [name]="transferMethodState ? stepIcons[stepStatus[transferMethodState]] : stepIcons.warning"
            ></vc-sprite-icons>
          </div>
          <div class="steps__item__row__content">
            <div class="steps__item__row__content__title" i18n="@@GET_PAID.STEPS.TRANSFERT_METHOD">
              Transfer method
            </div>
          </div>
        </div>
        <div class="steps__item__description">
          <ng-container
            *ngIf="transferMethodState === formStatus.FAILED"
            i18n="@@GET_PAID.STEPS.TRANSFERT_METHOD_FAILED"
          >
            Your transfer method expired, please update it.
          </ng-container>
          <div class="d-md-none">
            <ng-container *ngTemplateOutlet="transferMethodDetails"></ng-container>
          </div>
        </div>
        <button
          class="vc-btn vc-btn--primary vc-btn--medium d-md-none steps__item__button"
          [ngClass]="{'vc-btn--outline transferMethod': transferMethodState === formStatus.CONFIRMED}"
        >
          <ng-container
            *ngIf="showTransferMethodDetails; else createTrasnferMethod"
            i18n="@@GET_PAID.STEPS.TRANSFERT_METHOD_BUTTON_UPDATE"
          >
            Update
          </ng-container>
          <ng-template #createTrasnferMethod i18n="@@GET_PAID.STEPS.TRANSFERT_METHOD_BUTTON_ADD"
            >Add transfer method</ng-template
          >
        </button>
      </li>
      <!-- VERIFICATION KYC -->
      <li
        *ngIf="verificationState && verificationState !== formStatus.NOT_REQUIRED"
        class="steps__item verification steps__item--{{ stepStatus[verificationState] }}"
        [ngClass]="{
          'steps__item--active': selectedForm === getPaidForms.VERIFICATION,
          'steps__item--disabled':
            verificationState === formStatus.VERIFIED ||
            verificationState === formStatus.UNDER_REVIEW ||
            transferMethodState === formStatus.NOT_CREATED,
          'steps__item--deactivate': transferMethodState === formStatus.NOT_CREATED
        }"
        (click)="selectForm(getPaidForms.VERIFICATION)"
      >
        <div class="steps__item__row">
          <div class="steps__item__row__icon">
            <vc-sprite-icons
              *ngIf="stepIcons[stepStatus[verificationState]]"
              class="steps__item__row__icon"
              [name]="stepIcons[stepStatus[verificationState]]"
            ></vc-sprite-icons>
          </div>
          <div class="steps__item__row__content">
            <div class="steps__item__row__content__title" i18n="@@GET_PAID.STEPS.IDENTITY_VERIFICATION">
              Identity verification
            </div>
          </div>
        </div>
        <div class="steps__item__description">
          <div [ngSwitch]="verificationState">
            <div
              *ngSwitchCase="formStatus.REQUIRED"
              class="d-md-none"
              i18n="@@GET_PAID.STEPS.IDENTITY_VERIFICATION_REQUIRED"
            >
              To make sure you account remains secure and compliant we require additional information to confirm your
              identity.
            </div>
            <div *ngSwitchCase="formStatus.UNDER_REVIEW" i18n="@@GET_PAID.STEPS.IDENTITY_VERIFICATION_UNDER_REVIEW">
              Verification in progress: May take up to 72h
            </div>
            <div *ngSwitchCase="formStatus.FAILED" i18n="@@GET_PAID.STEPS.IDENTITY_VERIFICATION_FAILED">
              We couldn't verify your identity. Ensure the information you enter is the same as the information that
              appears on your proof of identity. Click to continue .
            </div>
          </div>
        </div>
        <button
          class="vc-btn vc-btn--primary vc-btn--medium d-md-none steps__item__button"
          (click)="selectForm(getPaidForms.VERIFICATION)"
          i18n="@@GET_PAID.STEPS.IDENTITY_VERIFICATION_BUTTON"
        >
          Verify
        </button>
      </li>
    </ul>

    <ng-container *ngTemplateOutlet="privacyPolicy"></ng-container>
  </nav>

  <div class="rightContainer">
    <vc-get-paid-reassurance [customerKYC]="customerInfo" [selectedForm]="selectedForm"></vc-get-paid-reassurance>
    <div *ngIf="(!selectedForm && !isWebView) || selectedForm !== getPaidForms.TRANSFERT_METHOD">
      <div class="d-none d-md-block updateContainer" *ngIf="showTransferMethodDetails">
        <p i18n="@@GET_PAID.TRANSFER_METHOD_UPDATE_MSG">
          If needed your payment methods can be updated at anytime here.
        </p>
        <ng-container *ngTemplateOutlet="transferMethodDetails"></ng-container>
        <button
          class="vc-btn vc-btn--outline vc-btn--medium updateContainer__button"
          (click)="openTransferMethodForm()"
          i18n="@@GET_PAID.STEPS.TRANSFERT_METHOD_BUTTON_UPDATE"
        >
          Update
        </button>
      </div>
    </div>
    <!-- Message to complete transfer method -->
    <div
      class="d-none d-md-block transferMethodActivation"
      *ngIf="!selectedForm && transferMethodState === formStatus.AWAITING_CONFIRMATION"
    >
      <div class="transferMethodActivation__title">
        <span class="transferMethodActivation__title__icon"></span>
        <span class="transferMethodActivation__title__text vc-text-m" i18n="@@GET_PAID.TRANSFER_METHOD_ACTIVATION.TITLE"
          >Step incomplete</span
        >
      </div>
      <div class="transferMethodActivation__content vc-text-m" i18n="@@GET_PAID.TRANSFER_METHOD_ACTIVATION.CONTENT">
        Your Transfer method activation is not complete, please finish the confirmation by entering the code that have
        been sent to your email adress.
      </div>
      <button
        class="vc-btn vc-btn--primary vc-btn--medium"
        (click)="selectForm(getPaidForms.TRANSFERT_METHOD)"
        i18n="@@GET_PAID.TRANSFER_METHOD_ACTIVATION.BUTTON"
      >
        Continue
      </button>
    </div>
    <!-- Forms -->
    <div class="formContainer" [ngClass]="{'d-none': !selectedForm}">
      <div *ngIf="!isWebView" class="backButton" (click)="backToSteps()">
        <vc-sprite-icons class="backButtonIcon" name="arrow-head-left"></vc-sprite-icons>
        <span i18n="@@GET_PAID.BUTTON_BACK">Back</span>
      </div>
      <vc-forms-container
        *ngIf="selectedForm"
        [selectedForm]="selectedForm"
        [isWebView]="isWebView"
        [customerKYC]="customerInfo"
        [userIsB2C]="userIsB2C"
        [userEmail]="userEmail"
        (formSubmitted)="onFormSubmitted($event)"
      ></vc-forms-container>
    </div>
  </div>
</div>
<ng-container *ngTemplateOutlet="privacyPolicy"></ng-container>
